document.addEventListener('DOMContentLoaded', function () {
  var productJsonEl = document.querySelector('[id^="ProductJson-"]');
  if (!productJsonEl) return;

  var productData = JSON.parse(productJsonEl.textContent);

  var radioInputs = document.querySelectorAll(
    'variant-radios input.product-form__radio'
  );
  var selectInputs = document.querySelectorAll(
    'variant-selects select[name^="options["]'
  );

  var optionInputs = Array.prototype.slice
    .call(radioInputs)
    .concat(Array.prototype.slice.call(selectInputs));

  if (!optionInputs.length) return;

  function getSelectedOptions() {
    var options = [];

    var radioGroups = {};
    radioInputs.forEach(function (el) {
      if (!radioGroups[el.name]) {
        radioGroups[el.name] = [];
      }
      radioGroups[el.name].push(el);
    });

    Object.keys(radioGroups).forEach(function (name) {
      var group = radioGroups[name];
      var checked = group.find(function (el) {
        return el.checked;
      });
      if (checked) {
        options.push(
          checked.value
            .replace(/Special_Double_Quote/g, '"')
            .replace(/Special_Slash/g, '/')
        );
      }
    });

    selectInputs.forEach(function (el) {
      options.push(
        el.value
          .replace(/Special_Double_Quote/g, '"')
          .replace(/Special_Slash/g, '/')
      );
    });

    return options;
  }

  function onVariantChange() {
    var selectedOptions = getSelectedOptions();
    if (!selectedOptions.length) return;

    var variant = productData.variants.find(function (v) {
      return v.options.every(function (opt, index) {
        return opt === selectedOptions[index];
      });
    });

    if (!variant) return;

    // Re-grab live elements (theme may have re-rendered them)
    var priceEls = document.querySelectorAll(
      '[id^="product-price-"] .price-item.price-item--regular, ' +
      '[id^="product-price-"] .price-item.price-item--sale'
    );

    // All variant id inputs on the page (product form, sticky form, etc.)
    var idInputs = document.querySelectorAll('input[name="id"]');


    // Update SKU
    var skuWrapper = document.querySelector('[data-sku]');
    var skuValueEl = skuWrapper
      ? skuWrapper.querySelector('.productView-info-value')
      : null;

    if (skuWrapper && skuValueEl) {
      if (variant.sku) {
        skuValueEl.textContent = variant.sku;
        skuWrapper.style.display = '';
      } else {
        skuWrapper.style.display = 'none';
      }
    }

    // Update hidden variant id for all Add to Cart forms
    if (idInputs.length) {
      idInputs.forEach(function (el) {
        el.value = variant.id;
      });
    }


    // Update price
    if (priceEls.length) {
      if (window.Shopify && Shopify.formatMoney) {
        var moneyFormat =
          (window.theme &&
            window.theme.strings &&
            window.theme.strings.moneyFormat) ||
          '£{{amount}}';

        var formatted = Shopify.formatMoney(variant.price, moneyFormat);

        priceEls.forEach(function (el) {
          el.innerHTML = formatted;
        });
      } else {
        var plain = (variant.price / 100).toFixed(2);
        priceEls.forEach(function (el) {
          el.textContent = plain;
        });
      }
    }

    // Update URL
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  optionInputs.forEach(function (el) {
    el.addEventListener('change', onVariantChange);
  });
});
